import useDatasetData from '@/components/DashboardPageV2/Desktop/Widgets/Shared/Hooks/useDatasetData'

import Line from '@/components/DashboardPageV2/Desktop/Widgets/Shared/Dynamic/Chart/Line'
import { convertToVPD } from '@/Util/MeasurementUtils'

export default function DatasetLine({ unit, config, ...props }) {
  const requiredMeasurements = ['temperature', 'humidity']
  const { datasetData, queryZones } = useDatasetData({
    measurements: requiredMeasurements,
    range: config.range,
    interval: config.interval
  })

  let chartData = {}

  if (datasetData) {
    for (let { zoneName } of queryZones) {
      const temperatureData = datasetData?.['temperature']?.[zoneName] || []
      const humidityData = datasetData?.['humidity']?.[zoneName] || []

      chartData[zoneName] = temperatureData.reduce(
        (result, temperature, index) => {
          const humidityDataPoint = humidityData[index]
          if (humidityDataPoint && temperature.x === humidityDataPoint.x) {
            result.push({
              x: temperature.x,
              y: convertToVPD({
                temperature: temperature.y,
                humidity: humidityDataPoint.y
              })
            })
          }

          return result
        },
        []
      )
    }
  }

  return (
    <Line
      {...props}
      data={chartData}
      unit={unit}
      config={config}
      queryZones={queryZones}
    />
  )
}
